<template>
  <div class="container">
    <div class="modal-header">
      <h5
        class="modal-title"
        id="PaymentModalCashTitle"
      >
        รายการใบเสร็จรับชำระ
      </h5>
      <button
        type="button"
        class="close"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div
      class="modal-body p-2"
      style="font-size: 18px;"
    >
      <div class="container pb-3 pl-3 pr-3">
       {{ this.edit_data }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['edit_data', 'getReceipt']
}
</script>


// WEBPACK FOOTER //
// src/components/pos/receipt_edit.vue